export default __webpack_public_path__ + "static/MediaContentTwo-eef77544e1ac244eb7da41c370abbbba.webp";